'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');

var _OMButtonWithPreloader = require('../../../../OMComponents/OMButtonWithPreloader/OMButtonWithPreloader');var _OMButtonWithPreloader2 = _interopRequireDefault(_OMButtonWithPreloader);

var _reduxFormValidators = require('../../../../../helpers/reduxFormValidators');

var _MessageForm = require('./MessageForm.scss');var _MessageForm2 = _interopRequireDefault(_MessageForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MessageForm = function MessageForm(_ref) {var
  onSubmit = _ref.onSubmit,
  loading = _ref.loading,
  onCancel = _ref.onCancel,
  inputComponent = _ref.inputComponent,
  translate = _ref.translate,
  isRtl = _ref.isRtl;return (

    _react2.default.createElement('form', { className: _MessageForm2.default.form },
      _react2.default.createElement(_reduxForm.Field, {
        name: 'message',
        component: inputComponent,
        placeholder: translate('propertyDetails', 'messagePlaceholder'),
        maxLength: '250',
        validate: [_reduxFormValidators.required],
        isRtl: isRtl }),

      _react2.default.createElement('div', { className: _MessageForm2.default.buttons },
        _react2.default.createElement(_OMButtonWithPreloader2.default, {
          onClick: onSubmit,
          innerText: translate('propertyDetails', 'messageButton'),
          showPreloader: loading,
          type: 'button',
          className: 'messagesFormButton' }),

        _react2.default.createElement('button', {
            type: 'button',
            className: _MessageForm2.default.transparentButton,
            onClick: onCancel },

          translate('propertyDetails', 'messageCancelButton')))));};exports.default =





MessageForm;

MessageForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  inputComponent: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/components/MessageForm/MessageForm.js
// module id = 2812
// module chunks = 0